import { GoftinoSnippet } from "@mohsen007/react-goftino";
import HeadsetMicIcon from '@mui/icons-material/HeadsetMic';
import { useState } from "react";

const GoftinoChat = () => {
    const [hideButton, setHideButton] = useState(false);

    return (
        <div
            style={{ width: "50px", height: "50px", position: "relative" }}
        >
            <GoftinoSnippet
                goftinoKey={"qzVes1"}
                onReady={() => {
                    window.Goftino.setWidget({
                        hasIcon: false,
                    });
                }}
                onClose={() => {
                    setHideButton(false);
                }}
            />
            <button
                onClick={() => {
                    window.Goftino.open();
                }}
                className="goftino-button"
                style={{
                    position: "fixed",
                    bottom: "10px",
                    right: "20px",
                    color: "white",
                    backgroundColor: "#BBA57A",
                    padding: 8,
                    borderRadius: "50%",
                    opacity: .8,
                    zIndex: 9999

                }}
            >
                <HeadsetMicIcon sx={{ color: "#fff", fontSize: "2rem" }} />
            </button>
        </div>
    );
};

export default GoftinoChat;
